export default "__VITE_ASSET__12d75f1b__"